import * as types from '../../actions/types';

const initialState = {
  streams: {},
  streamsErrorStatus: null,
  disciplines: {},
  disciplinesErrorStatus: null,
  view: null,
  viewIsLoading: false,
  viewErrorStatus: null,
};

export default function data (state = initialState, action) {
  switch (action.type) {

    case types.COMPLEX_TOPICS_DISCIPLINES_FETCH_COMPLETED:
      return {
        ...state,
        disciplines: action.complex,
        disciplinesErrorStatus: null,
      };

    // отказ сервера: перечень пустой объект (штатно там {count, complex_thematic_planning}),
    // код отдельным полем — перечень рисует блок ошибки, а не «данных нет»
    case types.COMPLEX_TOPICS_DISCIPLINES_FETCH_FAILED:
      return {
        ...state,
        disciplines: {},
        disciplinesErrorStatus: action.errorStatus,
      };

    case types.FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_COMPLETED:
      return {
        ...state,
        streams: action.complexData,
        streamsErrorStatus: null,
      };

    case types.FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_FAILED:
      return {
        ...state,
        streams: {},
        streamsErrorStatus: action.errorStatus,
      };

    case types.COMPLEX_TOPICS_DISCIPLINES_CLEAR:
      return {
        ...state,
        disciplines: {},
        disciplinesErrorStatus: null,
      };

    case types.COMPLEX_THEME_PLAN_STREAM_CLEAR:
      return {
        ...state,
        streams: {},
        streamsErrorStatus: null,
      };

    case types.COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_STARTED:
      return {
        ...state,
        viewIsLoading: true,
        view: null,
        viewErrorStatus: null,
      };

    case types.COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_COMPLETED:
      return {
        ...state,
        viewIsLoading: false,
        view: action.data,
        viewErrorStatus: null,
      };

    case types.COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_ERROR:
      return {
        ...state,
        viewIsLoading: false,
        view: null,
        viewErrorStatus: action.errorStatus,
      };

    case types.COMPLEX_TOPICS_DISCIPLINES_VIEW_CLEAR:
      return {
        ...state,
        view: null,
        viewIsLoading: false,
        viewErrorStatus: null,
      };

    default:
      return state;
  }
}
